function initializeObservers() {
  const images = document.querySelectorAll(".fade-in:not([data-observed])");
  const lazyVideos = document.querySelectorAll('.js-lazy-video:not([data-observed])');

  const imageObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add("show");
        imageObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });

  images.forEach((img) => {
    img.setAttribute('data-observed', 'true');
    imageObserver.observe(img);
  });

  if ('IntersectionObserver' in window) {
    const videoObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const video = entry.target;
          const source = video.querySelector('source');

          if (source && source.dataset.src) {
            source.src = source.dataset.src;
            video.load();
          }

          videoObserver.unobserve(video);
        }
      });
    });

    lazyVideos.forEach(video => {
      video.setAttribute('data-observed', 'true');
      videoObserver.observe(video);
    });

  } else {
    lazyVideos.forEach(video => {
      const source = video.querySelector('source');
      if (source && source.dataset.src) {
        source.src = source.dataset.src;
        video.load();
      }
      video.setAttribute('data-observed', 'true');
    });
  }
}

document.addEventListener("DOMContentLoaded", initializeObservers);
document.addEventListener("shopify:section:load", initializeObservers);
document.addEventListener("shopify:section:select", initializeObservers);
document.addEventListener("shopify:block:select", initializeObservers);